import { IVentureListItem, IStrategyDetail } from "@aspen/model";
import variables from "@aspen/theme/variables.module.less";

/**
 * 生成Fund/Strategy/Deal详情页插入的表格代码片段
 * @param info
 * @returns 返回生成的 HTML 表格代码，如果没有数据则返回空字符串
 */
export const generateProductDetailTableHTML = (
  info: IVentureListItem | IStrategyDetail | null,
  isOnlyTable?: boolean,
): string => {
  const data = info?.performanceReturn || [];
  if (!data?.length) {
    return info?.detailInformation || "";
  }
  const styleCode = `<style>table{width: 100%; border-collapse: collapse;}th,td{text-align: center; color: ${variables.whiteOp2}; border-right: 1px solid ${variables.moduleColor}; font-weight: normal;}</style>`;
  let tableCode = "<table>";
  data?.forEach((row, rowIndex) => {
    tableCode += `<tr ${
      rowIndex === 0
        ? `style="background-color:${variables.mainBgColor}; font-size: 14px; height: 32px"`
        : rowIndex % 2 === 0
          ? `style="background-color:${variables.mainBgColor}; font-size: 14px; height: 26px"`
          : `style="font-size: 14px; height: 26px"`
    }>`;
    row.forEach(col => {
      tableCode += `<${rowIndex === 0 ? "th" : "td"}>${col}</${rowIndex === 0 ? "th" : "td"}>`;
    });
    tableCode += "</tr>";
  });
  tableCode += "</table>";
  const tableData = styleCode + tableCode;
  if (isOnlyTable) {
    return tableData;
  }
  const scriptCode = `<script>var insertCode = '${tableData}';var container = document.getElementById('webTablePlaceholder');if (container !== null) {container.innerHTML = insertCode;}</script>`;
  return info?.detailInformation + scriptCode;
};
